import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../../assets/image/pattern-background.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2e164414"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "menu",
  ref: "el"
};
var _hoisted_2 = {
  class: "top"
};
var _hoisted_3 = {
  class: "left"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "col-item-cl0"
};
var _hoisted_6 = {
  class: "col-item-cl0-info"
};
var _hoisted_7 = {
  class: "col-item-cl0-info-tlt"
};
var _hoisted_8 = ["innerHTML"];
var _hoisted_9 = ["innerHTML"];
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-zhushi"
  }, null, -1);
});
var _hoisted_11 = {
  class: "col-item-cl0-info-desc"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "col-item-cl1"
  }, [/*#__PURE__*/_createElementVNode("div"), /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-jiantou"
  })], -1);
});
var _hoisted_13 = {
  class: "col-item"
};
var _hoisted_14 = {
  class: "col-item-cl0"
};
var _hoisted_15 = {
  class: "col-item-cl0-info"
};
var _hoisted_16 = {
  class: "col-item-cl0-info-tlt"
};
var _hoisted_17 = {
  class: "col-item-cl0-info-desc"
};
var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "col-item-cl1"
  }, [/*#__PURE__*/_createElementVNode("div"), /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-jiantou"
  })], -1);
});
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "pattern"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })], -1);
});
var _hoisted_20 = {
  class: "col-item-cl0"
};
var _hoisted_21 = {
  class: "col-item-cl0-info"
};
var _hoisted_22 = {
  class: "col-item-cl0-info-tlt"
};
var _hoisted_23 = {
  class: "col-item-cl0-info-desc"
};
var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "col-item-cl1"
  }, [/*#__PURE__*/_createElementVNode("div"), /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-jiantou"
  })], -1);
});
var _hoisted_25 = {
  class: "recommand"
};
var _hoisted_26 = {
  class: "recommand-content"
};
var _hoisted_27 = {
  class: "title"
};
var _hoisted_28 = {
  class: "desc"
};
var _hoisted_29 = {
  class: "options"
};
var _hoisted_30 = ["href", "onClick"];
var _hoisted_31 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-jiantou-you"
  }, null, -1);
});
import { useLang } from '@/hooks/lang';
import { useMatomo } from '@shining3d/matomo';
import _get from 'lodash/get';
import { VueCookieNext } from 'vue-cookie-next';
import { useRouter } from 'vue-router';
import BindProduct from '../../../bind-product/index.vue';
import OfflineActivation from '../../../offline-activation/index.vue';
export default {
  setup: function setup(__props) {
    var lang = VueCookieNext.getCookie('lang');
    var promote = reactive(_get(window, lang === 'zh-cn' ? 'app.global.promote.cn' : (window, lang === 'ja-jp' ? 'app.global.promote.ja' : 'app.global.promote.en')));
    var matomo = useMatomo();
    // const emits = defineEmits(['proClick']);
    var _useLang = useLang(),
      $t = _useLang.$t;
    var menus = reactive({
      activate: {
        type: 'activate',
        title: $t('home.activate'),
        desc: $t('home.activateDesc'),
        icon: 'icon-lixianjihuo1',
        tipIcon: 'icon-zhushi'
      },
      binding: {
        type: 'binding',
        title: $t('home.binding'),
        desc: $t('home.bindingDesc'),
        icon: 'icon-bangdingshebei',
        tipIcon: 'icon-zhushi'
      },
      product: {
        type: 'product',
        title: $t('home.product'),
        desc: $t('home.productDesc'),
        icon: 'icon-shebei'
      },
      support: {
        type: 'support',
        title: $t('home.support'),
        desc: $t('home.supportDesc'),
        icon: 'icon-xiazai-xian'
      }
    });
    var router = useRouter();

    // 切换tab
    function changeTab(type) {
      router.push(type);
    }
    var offlineDialog = ref(false);
    var productDialog = ref(false);
    var handleClick = function handleClick(item) {
      item.type === 'activate' ? offlineDialog.value = true : productDialog.value = true;
    };
    var handleSubmit = function handleSubmit() {
      router.push({
        path: '/product'
      });
    };
    var handleMatomo = function handleMatomo(item) {
      var type = item.type === 'BBS' ? '用户论坛' : '用户调研';
      var productLine = item.productLine === 'dental' ? '齿科' : '3D数字化';
      matomo.log('click', "\u9996\u9875|".concat(type, "|").concat(productLine), "\u67E5\u770B".concat(productLine).concat(type));
    };
    return function (_ctx, _cache) {
      var _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_unref(menus).activate, _unref(menus).binding], function (item) {
        return _openBlock(), _createElementBlock("div", {
          class: "left-item col-item",
          onClick: function onClick($event) {
            return handleClick(item);
          },
          key: item.type
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("i", {
          class: _normalizeClass(["iconfont", item.icon])
        }, null, 2), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(item.title), 1), _createVNode(_component_el_tooltip, {
          effect: "dark",
          placement: "bottom",
          "popper-class": "popper"
        }, {
          content: _withCtx(function () {
            return [item.type === 'activate' ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              innerHTML: _unref($t)('product.tooltip')
            }, null, 8, _hoisted_8)) : (_openBlock(), _createElementBlock("div", {
              key: 1,
              innerHTML: _unref($t)('bind.tooltip')
            }, null, 8, _hoisted_9))];
          }),
          default: _withCtx(function () {
            return [_hoisted_10];
          }),
          _: 2
        }, 1024)]), _createElementVNode("div", _hoisted_11, _toDisplayString(item.desc), 1)])]), _hoisted_12], 8, _hoisted_4);
      }), 128))]), _createElementVNode("div", {
        class: "right",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return changeTab(_unref(menus).product.type);
        })
      }, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("i", {
        class: _normalizeClass(["iconfont", _unref(menus).product.icon])
      }, null, 2), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("span", null, _toDisplayString(_unref(menus).product.title), 1)]), _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(menus).product.desc), 1)])]), _hoisted_18]), _hoisted_19])]), _createElementVNode("div", {
        class: "bottom col-item",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return changeTab(_unref(menus).support.type);
        })
      }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("i", {
        class: _normalizeClass(["iconfont", _unref(menus).support.icon])
      }, null, 2), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("span", null, _toDisplayString(_unref(menus).support.title), 1)]), _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(menus).support.desc), 1)])]), _hoisted_24]), _createVNode(OfflineActivation, {
        modelValue: offlineDialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return offlineDialog.value = $event;
        }),
        onSubmit: handleSubmit
      }, null, 8, ["modelValue"]), _createVNode(BindProduct, {
        modelValue: productDialog.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return productDialog.value = $event;
        })
      }, null, 8, ["modelValue"])], 512), _createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(promote), function (item) {
        return _openBlock(), _createElementBlock("div", {
          class: "promote",
          key: item.title,
          style: _normalizeStyle({
            'background-image': 'url(' + item.backgroundImageUrl + ')'
          })
        }, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_28, _toDisplayString(item.desc), 1), _createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.links, function (link) {
          return _openBlock(), _createElementBlock("a", {
            key: link.name,
            href: link.url,
            target: "_blank",
            onClick: function onClick($event) {
              return handleMatomo(link);
            }
          }, [_createElementVNode("span", null, _toDisplayString(link.name), 1), _hoisted_31], 8, _hoisted_30);
        }), 128))])])], 4);
      }), 128))])], 64);
    };
  }
};